export const useRoutingHistoryStore = defineStore('routeHistoryStore', () => {
  const routeHistory = ref<string[]>([]);
  const projectWorksheetPattern = ref<RegExp>(/^\/projects\/\d+\/worksheets\/(\d+)$/);
  const canNavigateToCalendar = ref<boolean>(false);
  const messageNavigated = ref<string>('');
  const openWorksheetStatus = ref<boolean>(false);
  const calendarEventDate = ref<string | undefined>(undefined);
  const calendarEvent = ref<CalendarEventListItemDTO | undefined>(undefined);

  function clearRouteHistory() {
    routeHistory.value = [];
  }

  function resetCanNavigateToCalendar() {
    canNavigateToCalendar.value = false;
  }

  const isPreviousRouteWorksheet = computed(() => {
    const history = routeHistory.value;

    if (history.length < 2) {
      return false;
    }

    const previousRoute = history[history.length - 2];

    return projectWorksheetPattern.value.test(previousRoute);
  });

  const previousWorksheetRoute = computed(() => {
    if (isPreviousRouteWorksheet.value) {
      return routeHistory.value[routeHistory.value.length - 2];
    }

    return undefined;
  });

  const previousRoute = computed(() => {
    return routeHistory.value[routeHistory.value.length - 2];
  });

  return {
    clearRouteHistory,
    resetCanNavigateToCalendar,
    canNavigateToCalendar,
    messageNavigated,
    calendarEventDate,
    calendarEvent,
    openWorksheetStatus,
    routeHistory,
    isPreviousRouteWorksheet,
    previousRoute,
    previousWorksheetRoute,
    projectWorksheetPattern
  };
});